import styled, { css } from 'styled-components'

import SVGAngleRight from '@Assets/SVG/AngleRight'
import { up } from '@Globals/Style/breakpoints'
import { resetButton } from '@Globals/Style/mixins'

export const EXPANDABLE_LIST_ITEM_SIZE = 40
export const EXPANDABLE_LIST_ITEM_SIZE_MARGIN = 2

const BUTTON_HEIGHT_COLLAPSED = 50
const BUTTON_HEIGHT_EXPANDED = 30

export const ExpandableListWrapper = styled.div(({ theme }) => `
  margin-top: ${theme.padding.phablet};
  position: relative;

  ${up('mobileStyleThreshold')} {
    margin-top: ${theme.padding.mobile};
  }
`)

export const ExpandableListElement = styled.ul<{ isExpanded?: boolean }>(({ theme }) => `
  border: 1px solid ${theme.colors.greyLighterer};
`)
export const ExpandableListItemWrapper = styled.li(({ theme }) => `
  border-bottom: 1px solid ${theme.colors.greyLighterer};

  &:last-child {
    border-bottom: none;
  }
`)

const innerWrapper = css`
  display: flex;
  align-items: center;
`

export const ExpandableListItemContentWrapper = styled.div(() => `${innerWrapper}`)
export const ExpandableListItemLink = styled.a(({ theme }) => `
  ${innerWrapper}

  &:focus,
  &:hover {
    background: ${theme.colors.greyLightest};
  }
`)

export const ExpandableListItemImageWrapper = styled.div(() => `
  flex: 0 0 ${EXPANDABLE_LIST_ITEM_SIZE}px;
  height: ${EXPANDABLE_LIST_ITEM_SIZE}px;
  position: relative;
  padding-top: ${EXPANDABLE_LIST_ITEM_SIZE_MARGIN}px;
  padding-left: ${EXPANDABLE_LIST_ITEM_SIZE_MARGIN}px;
  background: #fff;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: rgba(0, 0, 0, .04);
  }
`)

export const ExpandableListItemContent = styled.div(({ theme }) => `
  font-size: .875rem;
  padding-left: ${theme.padding.phablet};
`)

export const ExpandableListToggleIcon = styled(SVGAngleRight)`
  transform: rotate(-90deg);
  width: 1rem;
  height: 1rem;
  vertical-align: bottom;
`

export const ExpandableListIconWrapper = styled.div<{ isExpanded?: boolean }>(({ isExpanded }) => `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: top .1s ease;
  margin-top: ${isExpanded ? 0 : '1.25rem'};
  line-height: 1;
`)

export const ExpandableListToggleButton = styled.button<{ isExpanded?: boolean }>(({ isExpanded, theme }) => `
  ${resetButton};
  z-index: 1;
  width: 100%;
  position: relative;
  background: linear-gradient(#ffffff00, #fff);
  height: ${BUTTON_HEIGHT_EXPANDED}px;

  &:hover {
    background: linear-gradient(#ffffff00 0%, #ffffffbb 30%, #fff 100%);

    ${ExpandableListToggleIcon} {
      fill: ${theme.colors.primaryHover}
    }

    ${ExpandableListIconWrapper} {
      top: ${isExpanded ? 'calc(50% - 6px)' : 'calc(50% + 6px)'}
    }
  }

  ${!isExpanded
    ? `
      position: absolute;
      bottom: 0;
      height: ${BUTTON_HEIGHT_COLLAPSED}px;

      svg {
        transform: rotate(90deg)
      }
    `
    : ''}
`)

